import { render } from "./Component.vue?vue&type=template&id=24eef21c&scoped=true"
import script from "./Component.vue?vue&type=script&lang=js"
export * from "./Component.vue?vue&type=script&lang=js"

import "./Component.vue?vue&type=style&index=0&id=24eef21c&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24eef21c"]])

export default __exports__